import { reducerWithInitialState } from 'typescript-fsa-reducers';
import update from 'react-addons-update';
import {
    toggleLogInStatus,
    fetchUserProfile,
    clearUserProfile,
    toggleSessionCreate,
    fetchUserPreference,
    updateUserPreference,
    updateUserPreferenceManually
} from './user.actions';
import generateCollectionFromBookmarks from './user.middleware';

const initialUserState: UserStoreState = {
    isLoggedIn: false,
    isTableauSessionCreated: false,
    bookmarkPreference: undefined
};

const reducer = reducerWithInitialState(initialUserState);

reducer.case(toggleLogInStatus, (state, isLoggedIn) => {
    return { ...state, isLoggedIn };
});

reducer.case(toggleSessionCreate, (state: UserStoreState, isTableauSessionCreated: boolean) => {
    return { ...state, isTableauSessionCreated };
});

reducer.case(fetchUserProfile.async.done, (state, userInfo) => {
    // console.log('fetchInitialDataset.async.done', state, userInfo);
    return update(state, { userInfo: { $set: userInfo.result } });
});

const upsertBookmarksCollection = (state: UserStoreState, bookMarks: any[]) => {
    const targetId = 'bookmarks-collection';
    const generated = generateCollectionFromBookmarks(bookMarks as any);
    const bookmarksCollection = { ...generated, collectionId: targetId };
    const { collectionsList } = state as any;
    const { collections: rawCollections = [] } = collectionsList || {};
    const collections = Array.isArray(rawCollections) ? rawCollections : [];
    const idx = collections.findIndex((c: Collection) => c.collectionId === targetId);
    const nextCollections =
        idx >= 0
            ? collections.map((c, i) => (i === idx ? bookmarksCollection : c))
            : [...collections, bookmarksCollection];
    return nextCollections;
};
const applyBookmarkPreference = (state: UserStoreState, preference: any) => {
    const nextCollections = upsertBookmarksCollection(state, preference.bookMarks);

    return update(state, {
        bookmarkPreference: { $set: preference },
        bookmarkCollection: { $set: nextCollections }
    });
};

reducer.case(fetchUserPreference.async.done, (state, payload) => {
    return applyBookmarkPreference(state, payload.result);
});

reducer.case(updateUserPreference.async.done, (state, payload) => {
    return applyBookmarkPreference(state, payload.result);
});

reducer.case(updateUserPreferenceManually.async.done, (state, payload) => {
    return applyBookmarkPreference(state, payload.result);
});

reducer.case(clearUserProfile, state => {
    return update(state, { $set: initialUserState });
});

export { reducer, initialUserState };
